import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer" data-testid="footer">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="text-2xl mb-4 text-white font-['Playfair_Display']">Domaine du Normont</h3>
            <p className="text-white/70 mb-6 max-w-md font-['Outfit']">
              Villa de luxe des années 70 nichée au cœur d'une ville médiévale, aux portes de la forêt domaniale, 
              à seulement 45 minutes de Paris. Un écrin de verdure pour vos séjours et événements d'exception.
            </p>
            <p className="text-white/70 mb-6 font-['Outfit']">
              Suivez-nous sur les réseaux sociaux pour découvrir les coulisses du domaine et nos dernières actualités !
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="https://instagram.com/domainedunormont" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-4 py-2 border border-white/30 hover:border-[#C5A059] hover:text-[#C5A059] transition-colors"
                data-testid="instagram-link"
              >
                <Instagram className="w-5 h-5" />
                <span className="font-['Outfit'] text-sm">@domainedunormont</span>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm uppercase tracking-wider mb-6 text-white font-['Outfit']">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/booking" className="footer-link font-['Outfit']" data-testid="footer-booking">Réserver</Link>
              </li>
              <li>
                <Link to="/events" className="footer-link font-['Outfit']" data-testid="footer-events">Groupes & Événements</Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link font-['Outfit']" data-testid="footer-contact">Contact</Link>
              </li>
              <li>
                <Link to="/login" className="footer-link font-['Outfit']" data-testid="footer-client">Espace client</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm uppercase tracking-wider mb-6 text-white font-['Outfit']">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-white/70">
                <Mail className="w-4 h-4 text-[#C5A059]" />
                <a href="mailto:contact@domainedunormont.fr" className="font-['Outfit'] hover:text-[#C5A059] transition-colors">
                  contact@domainedunormont.fr
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/70">
                <Phone className="w-4 h-4 text-[#C5A059]" />
                <span className="font-['Outfit']">Sur demande</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm font-['Outfit']">
            © {new Date().getFullYear()} Domaine du Normont. Tous droits réservés.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="/legal" className="text-white/50 hover:text-white font-['Outfit']">Mentions légales</Link>
            <Link to="/cgv" className="text-white/50 hover:text-white font-['Outfit']">CGV</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
